module.exports = __webpack_public_path__ + "img/avergespeed.24fce9f8.jpeg";